<template>

	<section class="nettno-ads w-full mx-auto max-w-container group" :class="classList" data-nosnippet role="" v-if="ad">
		<div class="flex items-center justify-center" :class="marginClass">
			<div class="w-full mx-auto">
				<span class="block pb-2 text-sm text-gray-500 dark:text-gray-400">Annonsørinnhold</span>

				<intersect @enter="inViewPort = true">
					<div class="relative">
						<div
							class="block w-full"
							:style="style"
						>
							<img v-if="ad.article" :src="ad.article.image" @click="click" class="w-full object-contain" />

							<div class="w-full" :style="style" v-else>
								<img v-if="ad.image" :src="ad.image" loading="lazy" class="w-full object-contain m-0 not-prose" />

								<video
									v-if="ad.video"
									width="100%"
									height="auto"
									loop
									muted
									autoplay
									playsinline
									preload="metadata"
									class="w-full  object-contain m-0 not-prose"
									loading="lazy"
								>

									<source :src="ad.video" type="video/mp4" />
								</video>
							</div>
						</div>
						<a
							:href="url"
							target="_blank"
							:title="ad.title ? 'Annonse fra ' + ad.title : null"
							:ariaLabel="ad.title ? 'Annonse fra ' + ad.title : null"
							rel="sponsored"
							@click="click"
							class="absolute inset-0"
						>
							<span class="sr-only">Link for annonse</span>
						</a>
					</div>
				</intersect>
			</div>
		</div>
	</section>

</template>

<script>
import Intersect from "vue-intersect";

export default {
	name: "Ad",
	components: {
		intersect: Intersect,
	},
	props: {
		transformation: {
			type: String,
			required: true
		},
		position: {
			type: String,
			required: false,
			default: 'adSmall'
		},
		marginClass: {
			type: String,
			required: false,
			default: ''
		},
		classList: {
			type: String,
			required: false,
			default: ''
		},
		width: {
			type: Number,
			required: false,
			default: 0
		},
		height: {
			type: Number,
			required: false,
			default: 0
		},
		aspectRatio: {
			type: Number,
			required: false,
			default: 0
		}
	},
	data() {
		return {
			inViewPort: false,
			location: window.location.href,
			ad: null
		};
	},
	watch: {
		inViewPort: {
			handler(value) {
				if (value) {
					this.adView();
				}
			},
		},
	},
	async mounted() {
		await this.getAd();
	},
	computed: {
		url() {
			return this.ad?.article?.url ?? this.ad?.url;
		},
		style() {
			return this.aspectRatio ? `aspect-ratio: ${this.aspectRatio}; overflow:hidden;` : null;
		}
	},
	methods: {
		async getAd() {
			const ad = await this.$store.dispatch('getRandomAd', {
				position: this.position,
				transformation: this.transformation
			});

			this.ad = ad;
		},
		async click(evt) {
			// evt.preventDefault();

			try {
				await this.$store.dispatch('adClick', {
					sectionId: 18,
					typeId: 1,
					entryId: this.ad.id,
					location: this.location,
				});
			} catch {
				console.error('Failure during ad click');
			}
		},
		async adView() {
			try {
				await this.$store.dispatch('adView', {
					sectionId: 18,
					typeId: 0,
					entryId: this.ad.id,
					location: this.location,
				});
			} catch {
				console.error('Failure during ad view');
			}
		},
	},
};
</script>

<style lang="css" scoped>
a {
	cursor: pointer;
}
</style>

